<template>
    <div class="popularType-main newUi">
        <div class="popularType_content flex">
            <div class="content_center flexColumn" style="
            padding: 10px;
            justify-content: space-between;
          ">
                <div class="content_style" style="height: 100%;">
                    <div class="newUiHeaderDP">
                        施工过程文件资料列表
                        <!-- {{ titleMenuList[4] }} -->
                    </div>
                    <div class="style_content">
                        <div style="height: 100%; width: 100%; justify-content: space-between;" class="flex">
                            <div style="height: 100%; width: 25%;">
                                <div class="content_style" style="height: 100%;">
                                    <el-aside width="100%" class="elAside" style="height: 90%;overflow:hidden">
                                        <zTreeZN :zNodes="zNodes" zTreeRemenuId="zTreeRemenuId1" @getData="getDataList"
                                            @addFileZtree="addFileZtree" :options="{
                                                id: 'id',
                                                pid: 'parentid',
                                                label: 'tname',
                                                zTreeId: 'PdeptTree',
                                                delType: {
                                                    add: false,
                                                    update: false,
                                                    del: false,
                                                    addFile: upOrdelUserAuthority,
                                                },
                                            }" ref="zTree" />
                                    </el-aside>
                                </div>
                            </div>
                            <div style="height: 100%; width: 74%;">
                                <div class="content_style" style="height: 100%;">
                                    <el-table :data="dataList" highlight-current-row height="95%" :header-cell-style="{
                                        background: '#71A5D0',
                                        color: '#fff',
                                        textAlign: 'center',
                                    }" :cell-style="{ textAlign: 'center' }">
                                        <el-table-column type="index" label="序号" width="55">
                                        </el-table-column>
                                        <el-table-column prop="fname" label="文件名称">
                                            <template slot-scope="scope">
                                                <el-button size="small" style="color:#fff" type="text"
                                                    @click="lookImage(scope.row)">{{
                                                        scope.row.fname }}</el-button>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="status" label="操作" width="230">
                                            <template slot-scope="scope">
                                                <el-button size="small" type="primary" plain
                                                    @click="feedbackChange(scope.row)">反馈</el-button>
                                                <el-button v-if="downUserAuthority" size="small" type="primary" plain
                                                    @click="downChange(scope.row)">下载</el-button>
                                                <el-button v-if="upOrdelUserAuthority || scope.row.createuserid == uid"
                                                    size="small" type="warning" plain
                                                    @click="delChange(scope.row.id)">删除</el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content_left flexColumn">
                <div class="content_style" style="height: 100%;">
                    <div class="newUiHeaderDP">
                        问题反馈清单
                    </div>
                    <div class="style_content">
                        <el-table :data="feedbackList" highlight-current-row height="95%" :header-cell-style="{
                            background: '#71A5D0',
                            color: '#fff',
                            textAlign: 'center',
                        }" :cell-style="{ textAlign: 'center' }">
                            <el-table-column prop="title" label="标题">
                                <template slot-scope="scope">
                                    <el-button size="small" type="text" class="wirte" @click="questionChange(scope.row)"
                                        :title="scope.row.title">{{
                                            scope.row.title }}</el-button>
                                </template>
                            </el-table-column>
                            <el-table-column prop="username" label="指定回复人">
                                <template slot-scope="scope">
                                    {{scope.row.replayusers.map(i => i.user04).join('、')}}
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
            <!-- 预览 -->
            <LookIframe ref="iframebaseRef"></LookIframe>
            <!-- 新增文件 -->
            <el-dialog :close-on-click-modal="false" :modal-append-to-body="false" :title="'新增' + Addtitle"
                :visible.sync="ADDFileShow" width="50%" height="50%" :before-close="handleClose" class="inputStyle">
                <el-form v-if="titleNum == '1'" :model="processForm" :rules="processRule" ref="Updateform"
                    label-width="230px" class="demo-ruleForm mar-r80 ">
                    <el-form-item label="专项监测名称：" prop="val1">
                        <el-select v-model="processForm.val1" placeholder="请选择">
                            <el-option v-for="item in specialOption" :key="item.value" :label="item.label"
                                :value="item.label">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="楼栋号：" prop="val2">
                        <el-input v-model="processForm.val2" placeholder="必填，文本，手动输入"></el-input>
                    </el-form-item>
                    <el-form-item label="文件" prop="fileList" ref="imageFile">
                        <el-upload ref="upload" v-model="processForm.fileList" multiple class="upload-demo"
                            accept=".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf" :action="actionUrl" :on-change="handleChange"
                            :before-upload="beforeUpload">
                            <el-button size="medium" style="color: #333;">点击选择文件</el-button>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <el-form v-else-if="titleNum == '2'" :model="processForm" :rules="processRule" ref="Updateform"
                    label-width="180px" class="demo-ruleForm mar-r80">
                    <el-form-item label="设备规格型号：" prop="val1">
                        <el-input v-model="processForm.val1" placeholder="必填，文本，手动输入"></el-input>
                    </el-form-item>
                    <el-form-item label="设备应用户型编号：" prop="val2">
                        <el-input v-model="processForm.val2" placeholder="必填，文本，手动输入"></el-input>
                    </el-form-item>
                    <el-form-item label="APF检测值：" prop="val3">
                        <el-input v-model="processForm.val3" placeholder="必填，文本，手动输入"></el-input>
                    </el-form-item>
                    <el-form-item label="额定值冷量：" prop="val4">
                        <el-input v-model="processForm.val4" placeholder="必填，文本，手动输入"></el-input>
                    </el-form-item>
                    <el-form-item label="文件" prop="fileList" ref="imageFile">
                        <el-upload ref="upload" v-model="processForm.fileList" multiple class="upload-demo"
                            accept=".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf" :action="actionUrl" :on-change="handleChange"
                            :before-upload="beforeUpload">
                            <el-button size="medium" style="color: #333;">点击选择文件</el-button>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <el-form v-else-if="titleNum == '3'" :model="processForm" :rules="processRule" ref="Updateform"
                    label-width="180px" class="demo-ruleForm mar-r80">
                    <el-form-item label="设备规格型号：" prop="val1">
                        <el-input v-model="processForm.val1"></el-input>
                    </el-form-item>
                    <el-form-item label="设备应用户型编号：" prop="val2">
                        <el-input v-model="processForm.val2" placeholder="必填，文本，手动输入"></el-input>
                    </el-form-item>
                    <el-form-item label="新风量：" prop="val3">
                        <el-input v-model="processForm.val3" placeholder="必填，文本，手动输入"></el-input>
                    </el-form-item>
                    <el-form-item label="单位风量耗功率：" prop="val4">
                        <el-input v-model="processForm.val4" placeholder="必填，文本，手动输入"></el-input>
                    </el-form-item>
                    <el-form-item label="报告类型" prop="val5">
                        <el-select v-model="processForm.val5" placeholder="请选择">
                            <el-option v-for="item in reportOption" :key="item.value" :label="item.label"
                                :value="item.label">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="文件" prop="fileList" ref="imageFile">
                        <el-upload ref="upload" v-model="processForm.fileList" multiple class="upload-demo"
                            accept=".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf" :action="actionUrl" :on-change="handleChange"
                            :before-upload="beforeUpload">
                            <el-button size="medium" style="color: #333;">点击选择文件</el-button>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <el-form v-else-if="titleNum == '5'" :model="processForm" :rules="processRule" ref="Updateform"
                    label-width="180px" class="demo-ruleForm mar-r80">
                    <el-form-item label="灯具规格名称：" prop="val1">
                        <el-input v-model="processForm.val1"></el-input>
                    </el-form-item>
                    <el-form-item label="灯具功率：" prop="val2">
                        <el-input v-model="processForm.val2" placeholder="必填，文本，手动输入"></el-input>
                    </el-form-item>
                    <el-form-item label="应用房间名称：" prop="val3">
                        <el-input v-model="processForm.val3" placeholder="必填，文本，手动输入"></el-input>
                    </el-form-item>
                    <el-form-item label="文件" prop="fileList" ref="imageFile">
                        <el-upload ref="upload" v-model="processForm.fileList" multiple class="upload-demo"
                            accept=".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf" :action="actionUrl" :on-change="handleChange"
                            :before-upload="beforeUpload">
                            <el-button size="medium" style="color: #333;">点击选择文件</el-button>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <el-form v-else-if="titleNum == '9' || titleNum == '10' || titleNum == '12'" :model="processForm"
                    :rules="processRule" ref="Updateform" label-width="180px" class="demo-ruleForm mar-r80">
                    <el-form-item label="保温材料名称:" prop="val1">
                        <el-input v-model="processForm.val1"></el-input>
                    </el-form-item>
                    <el-form-item label="应用部位：" prop="val2">
                        <el-input v-model="processForm.val2" placeholder="必填，文本，手动输入"></el-input>
                    </el-form-item>
                    <el-form-item label="传热系数检测值" prop="val3">
                        <el-input v-model="processForm.val3" placeholder="必填，文本，手动输入"></el-input>
                    </el-form-item>
                    <el-form-item label="文件" prop="fileList" ref="imageFile">
                        <el-upload ref="upload" v-model="processForm.fileList" multiple class="upload-demo"
                            accept=".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf" :action="actionUrl" :on-change="handleChange"
                            :before-upload="beforeUpload">
                            <el-button size="medium" style="color: #333;">点击选择文件</el-button>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <el-form v-else :model="processForm" ref="Updateform" label-width="0px" class="demo-ruleForm mar-r80">
                    <el-form-item ref="imageFile">
                        <el-upload ref="upload" v-model="processForm.fileList" multiple class="upload-demo"
                            accept=".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf" :action="actionUrl" :on-change="handleChange"
                            :before-upload="beforeUpload">
                            <el-button size="medium" style="color: #333;">点击选择文件</el-button>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <el-row>
                    <el-col :span="2" :offset="22">
                        <el-button type="primary" @click="submitUpdata('Updateform')">确定</el-button>
                    </el-col>
                </el-row>
            </el-dialog>
            <!-- 反馈 -->
            <el-dialog :close-on-click-modal="false" :modal-append-to-body="false" title="反馈"
                :visible.sync="feedbackShow" width="55%" height="50%" :before-close="handleClose" class="inputStyle">
                <el-form :model="feedbackForm" :rules="feedbackRule" ref="Updatefeedback" label-width="200px"
                    class="demo-ruleForm mar-r80" style="padding-right: 60px;">
                    <el-form-item label="关联文件：" prop="fileName">
                        <el-input disabled v-model="feedbackForm.fileName" placeholder="必填，文本，手动输入"></el-input>
                    </el-form-item>
                    <el-form-item label="问题反馈清单标题：" prop="title">
                        <el-input type="text" maxlength="30" v-model="feedbackForm.title"
                            placeholder="请输入标题，限制30个汉字"></el-input>
                    </el-form-item>
                    <el-form-item label="问题反馈清单内容：" prop="strcount">
                        <ckediter4 ref="ck" v-model="feedbackForm.strcount" :disable="false"></ckediter4>
                    </el-form-item>
                </el-form>
                <el-row>
                    <el-col :span="2" :offset="21">
                        <el-button type="primary" style="width: 100%;"
                            @click="submitfeedback('Updatefeedback')">确定</el-button>
                    </el-col>
                </el-row>
            </el-dialog>
            <!-- 反馈问题回复预览 -->
            <el-dialog :close-on-click-modal="false" :modal-append-to-body="false" title="问题反馈清单预览"
                :visible.sync="ShowQuestion" width="80%" height="50%">
                <el-form :model="questionForm" label-width="150px" ref="addForm2" style="padding-right: 60px;">
                    <el-form-item label="关联文件：">
                        <div>
                            {{ questionForm.ywprojectfile != null ? questionForm.ywprojectfile.fname : "关联文件已被删除" }}
                        </div>
                    </el-form-item>
                    <el-form-item label="问题反馈清单标题：">
                        <div>{{ questionForm.title }}</div>
                    </el-form-item>
                    <el-row style="padding:0px">
                        <el-col :span="6">
                            <el-form-item label="清单状态：">
                                <div>{{ questionForm.strstatus }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="关闭时间：">
                                <div>
                                    {{ questionForm.status != 2 ? "未关闭" : questionForm.colsetime }}
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row style="padding:0px;margin-top: 20px;" v-for="(item, index) in questionForm.disposelsit"
                        :key="index">
                        <el-col :span="12">
                            <el-row style="padding:0px">
                                <el-col :span="12">
                                    <el-form-item :label="index == 0 ? '发起人：' : '追问人：'">
                                        <div>{{ item.fbusername }}</div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item :label="index == 0 ? '发起时间：' : '追问时间：'">
                                        <div>{{ item.fbdate }}</div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-form-item label="问题反馈清单内容：">
                                <ckediter4 v-model="item.fbcontent" :disable="true"></ckediter4>
                            </el-form-item>
                        </el-col>

                        <template v-if="questionForm.creatuser == uid && replyUserAuthority">
                            <el-col :span="12">
                                <el-row style="padding:0px">
                                    <el-col :span="12">
                                        <el-form-item label="回复人：">
                                            <div>{{ item.disusername }}</div>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="回复时间：">
                                            <div>
                                                {{ item.disposedate == "0001/01/01 00:00:00" ? "" : item.disposedate }}
                                            </div>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-form-item label="回复内容：" prop="disposecontent">
                                    <ckediter4 ref="ck" v-model="item.disposecontent"
                                        :disable="item.disposecontent != null ? true : false">
                                    </ckediter4>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2" :offset="22"
                                v-if="item.disusername == null && index + 1 == questionForm.disposelsit.length">
                                <el-button type="primary" style="width: 100%;"
                                    @click="questionBtn(item, false, index)">确定</el-button>
                            </el-col>
                            <el-col :span="4" :offset="20" v-else>
                                <div style="float: right;" v-if="index + 1 == questionForm.disposelsit.length">
                                    <el-button style="color:#333" @click="continueBtn()">继续追问</el-button>
                                    <el-button type="primary" v-show="zwStatus == true"
                                        @click="questionBtn(item, true, index)">关闭问题</el-button>
                                </div>
                            </el-col>
                        </template>
                        <template v-else>
                            <template
                                v-if="!(index + 1 == questionForm.disposelsit.length && replyUserAuthority == false) || item.disposecontent != null">
                                <el-col :span="12">
                                    <el-row style="padding:0px">
                                        <el-col :span="12">
                                            <el-form-item label="回复人：">
                                                <div>{{ item.disusername }}</div>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="回复时间：">
                                                <div>
                                                    {{ item.disposedate == "0001/01/01 00:00:00" ? "" : item.disposedate
                                                    }}
                                                </div>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-form-item label="回复内容：" prop="disposecontent">
                                        <ckediter4 ref="ck" v-model="item.disposecontent"
                                            :disable="item.disposecontent != null ? true : questionDisable">
                                        </ckediter4>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4" :offset="20"
                                    v-if="questionForm.creatuser == uid && index + 1 == questionForm.disposelsit.length">
                                    <div style="float: right;">
                                        <el-button style="color:#333" @click="continueBtn()">继续追问</el-button>
                                        <el-button type="primary" v-show="zwStatus == true"
                                            @click="questionBtn(item, true, index)">关闭问题</el-button>
                                    </div>
                                </el-col>
                                <el-col :span="2" :offset="22" v-else>
                                    <el-button
                                        v-if="item.disusername == null && index + 1 == questionForm.disposelsit.length"
                                        type="primary" style="width: 100%;"
                                        @click="questionBtn(item, false, index)">确定</el-button>
                                </el-col>
                            </template>
                        </template>
                    </el-row>
                    <el-row>
                        <el-col :span="12" v-if="zwStatus == false">
                            <el-form-item label="问题反馈清单内容:">
                                <ckediter4 ref="ck2" v-model="newFeedback.fbcontent" :disable="zwStatus"></ckediter4>
                                <el-col :span="2" :offset="21">
                                    <el-button style="margin-top:10px" type="primary"
                                        @click="questionBtn1()">确定</el-button>
                                </el-col>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import zTreeZN from "@//components/zTreeZN.vue";
import ckediter4 from "@/components/ck.vue";
import LookIframe from "@/components/LookIframe.vue";
import { download } from "@/tools/tool";
import {
    GetywproTreeList,
    GetYwFilesList,
    GetYWProUserAuth,
    AddYwFilesWithTree,
    DelYwFilesList,
    AddYwFeedback,
    GetYwFeedbackList,
    YWFbAskedAndReply,
} from "@/setAxios.js";
export default {
    name: "popularType",
    components: { zTreeZN, ckediter4, LookIframe },
    data() {
        return {
            uid: Number(localStorage.getItem("id")),
            id: null,
            zNodes: null,
            loading: false,
            Addtitle: "",
            titleNum: "1",
            ADDFileShow: false,
            dataList: [],
            processForm: {
                val1: '',
                val2: '',
                val3: '',
                val4: "",
                val5: '',
                fileList: []
            },
            processRule: {
                val1: [{ required: true, message: "请输入", trigger: "change" }],
                val2: [{ required: true, message: "请输入", trigger: "blur" }],
                val3: [{ required: true, message: "请输入", trigger: "blur" }],
                val4: [{ required: true, message: "请输入", trigger: "blur" }],
                val5: [{ required: true, message: "请输入", trigger: "blur" }],
                fileList: [
                    {
                        validator: (rule, value, callback) => {
                            const valid = value.length > 0
                            if (valid) {
                                return callback()
                            } else {
                                return callback(new Error(rule.message))
                            }
                        }, required: true, message: '请上传文件',
                    }
                ],
            },
            specialOption: [
                {
                    value: "1",
                    label: "室内温湿度监测",
                },
                {
                    value: "2",
                    label: "新风量检测",
                },
                {
                    value: "3",
                    label: "建筑整体气密性检测",
                },
                {
                    value: "4",
                    label: "新风热回收装置性能检测",
                },
                {
                    value: "5",
                    label: "照度及照明功率密度检测",
                },
                {
                    value: "6",
                    label: "围护结构热工缺陷检测",
                },
                {
                    value: "7",
                    label: "围护结构主体部位传热系数检测",
                },
            ],
            reportOption: [
                {
                    value: "1",
                    label: "型检报告",
                },
                {
                    value: "2",
                    label: "复验报告",
                },
            ],
            actionUrl: this.$store.state.baseUrl,
            // 人员权限
            upOrdelUser: [],
            downUser: [],
            replyUser: [],
            //预览
            ShowImage: false,
            src:
                "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
            // 反馈
            feedbackList: [],
            feedbackShow: false,
            feedbackForm: {},
            feedbackRule: {
                fileName: [{ required: true, message: "请输入", trigger: "blur" }],
                title: [{ required: true, message: "请输入", trigger: "blur" }],
                strcount: [{ required: true, message: "请输入", trigger: "blur" }],
            },
            ShowQuestion: false,
            questionForm: {
                ywprojectfile: {},
            },
            questionDisable: false,
            replayStatus: false, //回复状态
            submitStatus: false, //确认状态
            zwStatus: true, //追问状态
            newFeedback: {},
        };
    },
    computed: {
        upOrdelUserAuthority() {
            return this.upOrdelUser.includes(Number(localStorage.getItem("id")));
        },
        downUserAuthority() {
            return this.downUser.includes(Number(localStorage.getItem("id")))
        },
        replyUserAuthority() {
            return this.replyUser.includes(Number(localStorage.getItem("id")))
        },
    },
    created() {
        this.GetywproTree();
        this.GetYWProUserAuthUser(5);
        this.GetYWProUserAuthUser(6);
        this.GetFeedbackList();
    },
    methods: {
        handleClose(done) {
            this.feedbackShow = false;
            this.ADDFileShow = false;
            this.ShowQuestion = false;
            this.questionDisable = !this.questionDisable;
            this.submitStatus = false;
            this.replayStatus = true;
            this.zwStatus = true;
            this.questionForm = {};
            this.processForm = {
                val1: '',
                val2: '',
                val3: '',
                val4: "",
                val5: '',
                fileList: []
            }
            this.$refs.upload.clearFiles();
            done();
        },
        // 文件树
        GetywproTree() {
            this.loading = true;
            GetywproTreeList({
                params: { xid: this.$store.state.xid, type: 3 },
            }).then((res) => {
                this.zNodes = res.Data;
                this.loading = false;
            });
        },
        // 获取列表
        getDataList(ids) {
            this.loading = true;
            let params = {
                fname: "",
                xid: this.$store.state.xid,
                type: 3,
                treeid: ids,
                pageindex: 1,
                pageSize: 99999,
            };
            let fd = new FormData();
            for (var key in params) {
                fd.append(key, params[key]);
            }
            GetYwFilesList(fd).then((res) => {
                this.loading = false;
                if (res.Data && res.Data.length > 0) {
                    res.Data.forEach((item) => {
                        item.fname = this.removeDateComprehensive(item.fname);
                    });
                }
                this.dataList = res.Data;
            });
        },

        //移除时间
        removeDateComprehensive(filename) {
            return filename.replace(/_\d{4}[-/.]?\d{2}[-/.]?\d{2}([_\sT]\d{2}[:.-]?\d{2}[:.-]?\d{2})?(_|$)/g, '_');
        },

        // 获取项目过程模块人员权限
        GetYWProUserAuthUser(type) {
            let params = {
                xid: this.$store.state.xid,
                type: type,
            };
            GetYWProUserAuth({ params }).then((res) => {
                if (res.Data) {
                    if (type == 5) {
                        this.upOrdelUser =
                            res.Data.insertuids != null
                                ? res.Data.insertuids.split(",").map(Number)
                                : [];
                        this.downUser =
                            res.Data.downloaduids != null
                                ? res.Data.downloaduids.split(",").map(Number)
                                : [];
                    } else {
                        this.replyUser =
                            res.Data.replyuids != null
                                ? res.Data.replyuids.split(",").map(Number)
                                : [];
                    }
                }
            });
        },
        async addFileZtree(id, data) {
            this.ADDFileShow = true;
            this.Addtitle = data.tname;
            this.id = data.id;
            this.processForm.fileList = [];
            switch (data.tname) {
                case "超低能耗专项检测报告":
                    this.titleNum = "1";
                    break;
                case "暖通空调系统文件":
                    this.titleNum = "2";
                    break;
                case "新风系统文件":
                    this.titleNum = "3";
                    break;
                case "照明系统文件":
                    this.titleNum = "5";
                    break;
                case "屋面保温材料检测报告":
                    this.titleNum = "9";
                    break;
                case "围护墙保温材料检测报告":
                    this.titleNum = "10";
                    break;
                case "断热桥措施位置检测报告":
                    this.titleNum = "12";
                    break;
                default:
                    this.titleNum = "20";
                    break;
            }
        },
        // 添加文件
        submitUpdata(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let fd = new FormData();
                    this.processForm.fileList.forEach((file) => {
                        fd.append(`${file.name}^@^${file.versions}`, file.raw);
                    });
                    fd.append("xid", this.$store.state.xid);
                    fd.append("type", 3);
                    fd.append("targetId", this.id);
                    for (var key in this.processForm) {
                        fd.append(key, this.processForm[key]);
                    }
                    AddYwFilesWithTree(fd).then((res) => {
                        if (res.Code != 0) {
                            this.$message.success("上传成功");
                            this.processForm = {
                                val1: '',
                                val2: '',
                                val3: '',
                                val4: "",
                                val5: '',
                                fileList: []
                            }
                            this.ADDFileShow = false;
                            this.$refs.upload.clearFiles();
                            this.getDataList();
                        } else {
                            this.$message.error(res.Message);
                        }
                    });
                } else {
                    this.$message.error("验证失败！");
                    return false;
                }
            });
        },
        handleChange(file, fileList) {
            // this.fileList = fileList;
            this.$nextTick(() => {//等待照片上传完成，
                this.$refs.imageFile.clearValidate('fileList')
            })
            this.processForm.fileList = fileList;
        },
        beforeUpload(file) {
            var index = file.name.lastIndexOf(".");
            var suffix = file.name.substring(index + 1);
            var suffixs = ["doc", "docx", "pdf", "ppt", "pptx", "xls", "xlsx"];
            if (suffixs.indexOf(suffix) == -1) {
                this.$message({
                    message: "上传文件只能是 word、excel、ppt、pdf格式!",
                    type: "warning",
                });
                return false;
            }
            return true;
        },
        // 预览
        lookImage(data) {
            this.$refs.iframebaseRef.LookItemPics(data.fpath);
        },
        // 反馈
        feedbackChange(data) {
            if (this.replyUser.length == 0) {
                this.$message.warning("请联系管理员设置指定回复人！")
                return false;
            }
            this.feedbackShow = true;
            this.feedbackForm = {
                fileId: data.id,
                fileName: data.fname,
                title: "",
                strcount: "",
            };
        },
        GetFeedbackList() {
            let params = {
                searchword: "",
                projectid: this.$store.state.xid,
                type: 2,
                status: -1,
                pageindex: 1,
                pagesize: 99999,
                treeid: 0,
            };
            let fd = new FormData();
            for (var key in params) {
                fd.append(key, params[key]);
            }
            GetYwFeedbackList(fd).then((res) => {
                // 过滤已关闭
                this.feedbackList = res.Data.filter((el) => el.strstatus != "已关闭");
            });
        },
        submitfeedback(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid && this.feedbackForm.strcount.length > 0) {
                    let fd = new FormData();
                    this.feedbackForm.strcount = this.$refs.ck.ckeditor.getData();
                    fd.append("projectid", this.$store.state.xid);
                    fd.append("type", 2);
                    fd.append("fileId", this.feedbackForm.fileId);
                    fd.append("title", this.feedbackForm.title);
                    fd.append("strcount", this.feedbackForm.strcount);
                    AddYwFeedback(fd).then((res) => {
                        if (res.Code != 0) {
                            this.GetFeedbackList();
                            this.$message.success("上传成功");
                            this.feedbackForm = {};
                            this.feedbackShow = false;
                        } else {
                            this.$message.error(res.Message);
                        }
                    });
                } else {
                    this.$message.error("验证失败！");
                    return false;
                }
            });
        },
        // 做反馈操作
        questionChange(data) {
            this.questionForm = data;
            //回复人员、和发起反馈的人有权限
            if (
                this.replyUser.includes(Number(localStorage.getItem("id"))) === true ||
                this.questionForm.creatuser === Number(localStorage.getItem("id"))
            ) {
                // 权限
                //状态回复设置
                if (data.status === 0) {
                    //
                    this.replayStatus = false;
                    this.questionDisable = false;
                    this.submitStatus = false;
                } else if (data.status === 1) {
                    //回复待确认
                    this.replayStatus = true;
                    this.questionDisable = true;
                    this.submitStatus = true;
                    this.zwStatus = true;
                } else if (data.status === 2) {
                    //已关闭
                    this.submitStatus = true;
                    this.questionDisable = true;
                    this.replayStatus = false;
                }
            } else {
                this.questionDisable = true;
                this.replayStatus = false;
            }
            this.ShowQuestion = true;
        },
        // 确认回复
        questionBtn(data, status, index) {
            let result = false;
            this.questionForm.disposelsit.forEach((el) => {
                if (el.disposecontent != null) {
                    // 都不为空
                    result = true;
                } else {
                    // 有空数据
                    this.$message.error("请填写完成数据!");
                    result = false;
                }
                return result;
            });
            // result, true为不空,false为空
            if (result) {
                data.disposecontent = this.$refs.ck[index].ckeditor.getData();
                let params = {
                    fbid: this.questionForm.id,
                    projectid: this.$store.state.xid,
                    type: 2,
                    isclose: status,
                    disposeid: data.id,
                    strcontent: !status ? data.disposecontent : ''
                };
                let fd = new FormData();
                for (var key in params) {
                    fd.append(key, params[key]);
                }
                YWFbAskedAndReply(fd).then((res) => {
                    if (res.Code != 0) {
                        this.$message.success("操作成功");
                        this.ShowQuestion = false;
                        this.replayStatus = true;
                        this.questionDisable = true;
                        this.GetFeedbackList();
                    } else {
                        this.$message.error(res.Message);
                    }
                });
            }
        },
        // 追问
        continueBtn(data) {
            this.newFeedback = {
                id: 0,
                feedbackid: this.questionForm.id,
                fbcontent: "",
            };
            this.zwStatus = false;
        },
        // 追问回复
        questionBtn1() {
            this.newFeedback.fbcontent = this.$refs.ck2.ckeditor.getData();
            let params = {
                fbid: this.newFeedback.feedbackid,
                projectid: this.$store.state.xid,
                type: 2,
                isclose: false,
                disposeid: 0,
                strcontent: this.newFeedback.fbcontent,
            };
            let fd = new FormData();
            for (var key in params) {
                fd.append(key, params[key]);
            }
            YWFbAskedAndReply(fd).then((res) => {
                if (res.Code != 0) {
                    this.$message.success("操作成功");
                    this.ShowQuestion = false;
                    this.zwStatus = true;
                    this.GetFeedbackList();
                } else {
                    this.$message.error(res.Message);
                }
            });
        },
        //下载
        downChange(data) {
            let name = data.fname.slice(data.fname.lastIndexOf("/") + 1);
            try {
                download(
                    this.$store.state.baseUrl + data.fpath,
                    name + data.fpath.substr(data.fpath.lastIndexOf("."))
                );
            } catch (error) {
                this.$message.error("导出失败");
            }
        },
        // 删除
        delChange(id) {
            this.$confirm("此操作将移除所选文件, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                let params = {
                    ids: id,
                };
                DelYwFilesList(params).then((res) => {
                    if (res.Code > 0) {
                        this.$message({
                            type: "success",
                            message: "移除成功!",
                        });
                    }
                    this.getDataList();
                });
            }).catch(() => {
                this.$message({
                    type: "info",
                    message: "已取消操作",
                });
                this.loading = false;
            });
        },
    },
};
</script>
<style lang="less" scoped>
.popularType-main {
    width: 100%;
    height: calc(100% - 10px);
    padding-top: 10px;

    .popularType_content {
        width: 100%;
        height: 100%;

        .content_left {
            width: 25%;
            height: 100%;
        }

        .content_center {
            width: 75%;
            height: 100%;
        }
    }

    .wirte {
        color: #fff;
        font-size: 13px;
    }

    .flex {
        width: 100%;
    }

    .menuStyle {
        background-image: url("../../../assets/img/Wisdom/Group\ 1901.png");
        background-repeat: no-repeat;
        background-position: center center;
        cursor: pointer;
        padding: 0px 40px;
        box-sizing: content-box;
        width: 14%;
        height: 100%;
        color: #fff;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .isActive {
        background-image: url("../../../assets/img/Wisdom/Group\ 3_1.png");
    }

    .content_style {
        width: 100%;
        height: 33%;

        .style_title {
            background-image: url("../../../assets/img/Wisdom/Group 3.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            font-size: 14px;
            padding: 10px 25px;
            font-weight: bold;
            color: #fff;
        }

        .style_content {
            height: calc(100% - 74px);
            margin-top: 10px;
            background-color: rgba(0, 133, 247, 0.1);
            width: calc(100% -20px);
            padding: 10px;
            color: #fff;

            .bj_1 {
                background-image: url("../../../assets/img/Wisdom/椭圆\ 1\ 拷贝\ 31\ 灰大素材\ 拷贝\ 1.png");
                background-repeat: no-repeat;
                background-size: cover;
                background-position: center;
                text-align: center;
                font-weight: bold;
                width: 40%;
                height: 30%;
            }

            .bj_2 {
                background-image: url("../../../assets/img/Wisdom/1\ 86006.png");
                background-repeat: no-repeat;
                background-size: contain;
                background-position: 10% center;
                text-align: center;
                font-weight: bold;
                padding: 8px;
                letter-spacing: 5px;
                font-size: 20px;
                text-align: center;
                color: #04e8f8;
                font-family: "fzfs" !important;
            }

            .tian {
                position: relative;

                &::after {
                    position: absolute;
                    content: "天";
                    right: -30%;
                    color: #fff;
                    bottom: 2px;
                }
            }
        }
    }



    // 走马灯--图标改变
    .swiper {
        width: 80%;
        height: 100%;
    }

    .el-carousel__container {
        height: 100%;
    }

    .left-img1 {
        margin-right: 5px;
        cursor: pointer;
    }

    .right-img1 {
        margin-left: 5px;
        cursor: pointer;
    }

    .el-carousel__arrow--left,
    .el-carousel__arrow--right {
        display: none;
    }

    .el-carousel__item {
        width: 100%;

        .carousek {
            width: 100%;

            .carousel_Title {
                width: 100%;
                height: 40px;
                margin-top: 10px;
                font-size: 15px;
                justify-content: flex-start;
                padding-left: 10px;
                background-image: url("../../../assets/img/Intelligence/Group\ 2091.png");
                background-repeat: no-repeat;
                background-size: 100% 100%;
                /* 设置背景图片的位置以及重复方式 */
                background-position: center top;
            }

            .carousel_content {
                height: 55%;
                margin-top: 10px;

                .content_mian {
                    width: 80%;
                    height: 70%;
                    margin-left: 10px;
                    font-size: 12px;
                }
            }
        }
    }

    /deep/.inputStyle .el-input.is-disabled .el-input__inner {
        color: #ccc !important;
    }

    /deep/.inputStyle .el-input .el-input__inner {
        color: #333 !important;
        /* 修改为你想要的颜色 */
    }

    /deep/.inputStyle .el-input.is-disabled .el-input__inner {
        color: #ccc !important;
    }

    /deep/.inputStyle .el-input .el-input__inner {
        color: #333 !important;
        /* 修改为你想要的颜色 */
    }

    .font_col2 {
        margin-left: 10px;
        color: #4edce1;
    }
}
</style>
